import AppRoutes from '@components/AppRoutes';
import { ThemeProvider } from '@mui/material';
import theme from '@modules/theme';
import { ProSidebarProvider } from 'react-pro-sidebar';
import ErrorBoundary from '@components/ErrorBoundary';
import { InterviewsProvider } from '@providers/InterviewsProvider';
import FirebaseAuthentication from '@components/FirebaseAuthentication';

function App() {
    return (
        <ErrorBoundary location="App Level">
            <ProSidebarProvider>
                <ThemeProvider theme={theme}>
                    <FirebaseAuthentication>
                        <InterviewsProvider>
                            <AppRoutes />
                        </InterviewsProvider>
                    </FirebaseAuthentication>
                </ThemeProvider>
            </ProSidebarProvider>
        </ErrorBoundary>
    );
}

export default App;
